import { useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AppHeader } from "@/components/AppHeader";
import { EditorToolbar, SplitLayout } from "@/components/docs/EditorChrome";
import { ResumeForm } from "@/components/docs/ResumeForm";
import { TailorDialog } from "@/components/docs/TailorDialog";
import { MatchDialog } from "@/components/docs/MatchDialog";
import { ShareDialog } from "@/components/docs/ShareDialog";
import { ResumeTemplate } from "@/components/docs/Templates";
import { PaperPreview } from "@/components/docs/PaperPreview";
import { StylePicker } from "@/components/docs/StylePicker";
import { FitOnePage } from "@/components/docs/FitOnePage";
import { PricingDialog } from "@/components/PricingDialog";
import { useDocEditor } from "@/lib/useDocEditor";

export default function ResumeEditor() {
  const { id } = useParams();
  const ed = useDocEditor(id);
  const [tab, setTab] = useState("edit");
  const [pages, setPages] = useState(1);
  const { doc } = ed;

  if (!doc) return <div className="flex h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-thread" /></div>;
  const setData = (data) => ed.update({ data });

  return (
    <div className="min-h-screen bg-paper" data-testid="resume-editor">
      <AppHeader />
      <EditorToolbar doc={doc} update={ed.update} saveState={ed.saveState} onDownload={ed.download} exporting={ed.exporting}>
        <MatchDialog api={ed.api} data={doc.data} />
        <TailorDialog api={ed.api} data={doc.data} onApply={(r) => setData({ ...doc.data, ...r })} />
        <ShareDialog api={ed.api} doc={doc} onChange={ed.patchLocal} />
      </EditorToolbar>
      <SplitLayout tab={tab} setTab={setTab}
        form={<ResumeForm data={doc.data} onChange={setData} api={ed.api} />}
        preview={<><StylePicker type="resume" template={doc.template} accent={doc.accent} onChange={ed.update} />
          <PaperPreview watermark={!doc.can_download} testId="resume-preview" pageBreaks onPages={setPages}
            footer={pages > 1 && <FitOnePage api={ed.api} data={doc.data} pages={pages} onApply={setData} />}><ResumeTemplate template={doc.template} data={doc.data} accent={doc.accent} /></PaperPreview></>}
      />
      <PricingDialog open={ed.pricingOpen} onOpenChange={ed.setPricingOpen} docId={doc.id} returnPath={`/resume/${doc.id}`} beforeCheckout={ed.save} />
    </div>
  );
}
